import React from 'react';

import './RemovingFilePopup.scss';

export default function RemovingFilePopup(props) {
  const { deleteFileSpaceFile, fileKey, organizationName } =
    props.removingFilePopup;

  return (
    <section className="removingFilePopup">
      <div className="removingFilePopup_content">
        <p className="removingFilePopup_title">
          Wil je dit bestand verwijderen voor jou en je zorgverlener?
        </p>

        <button
          onClick={() => {
            deleteFileSpaceFile({ variables: { fileKey, organizationName } });

            props.showRemovingFilePopup(null);
          }}
        >
          Ja
        </button>

        <button
          className="removingFilePopup_button_inactive"
          onClick={() => props.showRemovingFilePopup(null)}
        >
          Nee
        </button>
      </div>
    </section>
  );
}
